module.exports = __webpack_public_path__ + "static/media/MSP.f363b86d.jpg";